<template>
    <v-flex :class="{'app-card-listing xs12': true, 'md6': grid}">
        <v-card :class="{'border border--grey_2 _card-item': true, '_card-item--small': grid}"
                light
                flat>
            <v-flex>
                <v-container pa-0>
                    <v-layout row wrap _card-body>
                        <v-flex :class="{'xs12': true, 'md6': !grid}">
                            <v-layout row wrap>
                                <v-flex xs12 class="_card--header" px-3>
                                    <slot name="header"></slot>
                                </v-flex>
                                <v-flex xs12 px-3>
                                    <v-layout row _details>
                                        <slot name="details">
                                            <v-flex xs6>
                                                <div>{{type === 'job' ? 'Type of work' : 'Looking for'}}</div>
                                                <div v-if="type === 'job'" class="text-no-wrap">Children</div>
                                                <div>Hourly rate</div>
                                            </v-flex>
                                            <v-flex xs6 class="font--medium">
                                                <div class="maindescription-parent">
                                                    <span  v-if="checkloggedin == false" :class="{'blurreddiv-pricing': true}" ></span>
                                                    <div class="text-truncate">
                                                        <span>{{typeWorkList ? typeWorkList.name : '---'}}</span>
                                                    </div>
                                                    <div class="text-truncate" v-if="type === 'job'">
                                                    <!--
                                                        <span>{{item.child_count}} children:</span>
                                                    -->
                                                        <span v-for="(age, index) in ageList" v-bind:key="index">
                                                            {{ageList.length !== (index + 1) ? age.name+',' : age.name  }}</span>
                                                    </div>

                                                    <div class="pricing">
                                                        <div v-if="type === 'job'">
                                                            ${{ item.payperhour && item.payperhour > 0 ? item.payperhour : 'Not Shared' }}
                                                            </div>

                                                            <div v-else>
                                                            ${{ item.price_min > 0 ? item.price_min : 'Not Shared' }} 
                                                            {{ item.price_min !== item.price_max && item.price_max > 0 ? ' - ' + item.price_max : '' }}
                                                        </div>
                                                    </div>
                                                </div>
                                            </v-flex>
                                        </slot>
                                    </v-layout>
                                </v-flex>
                                <v-flex :class="{'xs12 px-3': true}">
                                    <div class="_qualifications d-flex">
                                        <v-tooltip v-for="item in caregivers"
                                                :key="item.slug"
                                                :lazy="true"
                                                content-class="app-tooltip"
                                                nudge-bottom="0"
                                                color="white"
                                                bottom>
                                            <app-svg-icon slot="activator"
                                                        :class="{'primary--text': item.isActive}"
                                                        :name="`brand/NG_${item.slug.toString().toUpperCase()}`"></app-svg-icon>
                                            <span class="text--charcoal"
                                                style="font-size: 1rem">{{item.name | capitalize}}</span>
                                        </v-tooltip>
                                    </div>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                        <v-flex :class="{'xs12 px-3': true, 'md6': !grid}">
                            <div class="_qualifications d-flex">
                                <v-tooltip v-for="item in qualifications"
                                           :key="item.slug"
                                           :lazy="true"
                                           
                                           content-class="app-tooltip"
                                           nudge-bottom="0"
                                           color="white"
                                           bottom>
                                    <app-svg-icon slot="activator"
                                                  :class="{'primary--text': item.isActive}"
                                                  :name="`brand/NG_${item.slug.toString().toUpperCase()}`"></app-svg-icon>
                                    <span class="text--charcoal"
                                          style="font-size: 1rem">{{item.name | capitalize}}</span>
                                </v-tooltip>
                            </div>
                            <slot name="description">
                                <div class="maindescription-parent" >
                                   <!-- <span  v-if="checkloggedin == false && $vuetify.breakpoint.smAndDown==false" :class="{'blurreddiv': true, 'hidden-xs-only hidden-sm-and-up': grid}" ></span>
                                    <span  v-if="checkloggedin == false && $vuetify.breakpoint.smAndDown==true" :class="{'blurreddiv': true, 'hidden-xs-only hidden-sm-and-up': grid}"></span> -->
                                    <p v-line-clamp:20="$vuetify.breakpoint.smAndDown ? definelength_mobile: definelength_web"
                                    :class="{'text-small ma-0 _desc new_desc': true, 'hidden-xs-only hidden-sm-and-up': grid}">
                                        {{item.description}}</p>
                                </div>
                                <!--<img v-if="check_img_show" style="width:100%;" :id="`imageContainer_`" :src=getinfo_src>-->
                                <img v-if="check_img_show" class="image-blur" src="@/assets/img/img-blur.png"/>
                            </slot>
                            <div class="hidden-md-and-up mt-3 mb-2"
                                 :class="{'hidden-xs-only hidden-sm-and-up': grid}" @click="viewprofile">
                                <app-btn-view-profile :item="item" class="d-link text-small">
                                    {{type === 'job' ? 'View job' : 'View profile'}}
                                </app-btn-view-profile>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
            <v-flex v-if="!hideActions"
                    class="border--top border--grey_2 _actions d-flex align-center">
                <v-layout row wrap>
                    <v-flex :class="{'xs12 d-flex px-3': true, 'md12': !grid}">
                        <div class="_actions--items">

                            <app-btn-chat-room
                                :user-ids="[item.user_id || item.id]"
                                class="d-link d-inline ma-0 d-link--contact pl-0 text-xs-left"
                                :class="{'subscription-expired': (isParent && subscriptionExpired && type !== 'job')}"
                                flat
                                
                                >
                                <div @click="click_job_event(type)">
                                    <app-svg-icon name="brand/NG_CONTACT"></app-svg-icon>
                                    {{ type === 'job' ? 'Apply' : 'Contact' }}
                                </div>
                            </app-btn-chat-room>


                            <a href="#"
                               @click.stop.prevent="shortlist">
                                <app-svg-icon
                                        :name="`brand/NG_FAVOURITES${item.is_favorite ? '_FILL' : ''}`"></app-svg-icon>
                                Shortlist
                            </a>
                            <a href="#"
                               @click.stop.prevent="recommend">
                                <app-svg-icon name="brand/NG_INBOX"></app-svg-icon>
                                Recommend
                            </a>
                            <v-flex 
                            :class="{'hidden-sm-and-down': !grid, 'hidden-xs-only hidden-sm-and-up': grid}" @click="viewprofile">
                        <app-btn-view-profile :item="item" class="d-link">
                            {{type === 'job' ? 'View job' : 'View profile'}}
                        </app-btn-view-profile>
                    </v-flex>
                        </div>
                    </v-flex>
                    
                </v-layout>
            </v-flex>
        </v-card>
    </v-flex>
</template>

<script>
  import AppBtnViewProfile from '../../app-buttons/app-btn-view-profile'
  import AppBtnChatRoom from '../../app-buttons/app-btn-chat-room'

  export default {
    name: 'app-card-listing-base',
    components: {AppBtnChatRoom, AppBtnViewProfile},
    props: {
      hideActions: Boolean,
      grid: Boolean,
      type: String, // <- nanny/job
      item: Object
    },

    data () {
      return {
        icons: [
          'non_smoker',
          'drivers_licence',
          'has_car', 'pets',
          'first_aid',
          'light_housework',
          'meal_prep',
          'cooking_baking',
          'household_cleaning',
          'ages_0-1',
          'house',
          'anaphylaxis',
          'coffee_club',
          'active',
          'creative_play'
        ],
        checkloggedin:Boolean,
        getinfo_src:String,
        check_img_show:Boolean,
        definelength_mobile:String,
        definelength_web:String,

      }
    },

    mounted(){
        if (!this.$auth.check()) {
            this.checkloggedin=false
        }else{
            this.checkloggedin=true
        }

        /* start the text encryption process */
        this.check_img_show=false;
        this.definelength_mobile=3
        this.definelength_web=7
        if (!this.$auth.check()) {
        if(this.item.description_length>0){
            this.definelength_mobile=1
            this.definelength_web=1
            var blurAmount=5;
            var dummytext= "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has \nbeen the industry's standard dummy text ever since the 1500s,\nwhen an unknown printer took a galley of type and scrambled it \nto make a type specimen book. It has survived not only five centuries, but also the leap into electronic \ntypesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more \nrecently with desktop publishing software like Aldus PageMaker including versions of \nLorem Ipsum."
            //var uniqueContainerId = 'imageContainer_' + this.item.last_name;
            var customText=dummytext.substring(0,this.item.description_length)
            var uniqueContainerId = 'imageContainer_';
            

            // Call the function to apply blur with custom text and blur amount
           // applyBlur(customText, blurAmount, uniqueContainerId);

            var canvas = document.createElement('canvas');
            canvas.width = 300; // Set canvas width
            canvas.height = 150; // Set canvas height
	  

            // Get the canvas 2D context
            var ctx = canvas.getContext('2d');

            // Set the blur filter
            //ctx.filter = 'blur(' + blurAmount + 'px)';
            ctx.filter = "blur(5px)";

            // Split the custom text into lines based on line breaks
            var lines = customText.split('\n');

            // Draw each line on the canvas
            ctx.font = '12px Arial'; // Adjust font size as needed
            var lineHeight = 25; // Adjust line height as needed`

            for (var i = 0; i < lines.length; i++) {
                ctx.fillText(lines[i], 10, 23 + i * lineHeight,280); // Adjust position based on canvas size
            }

            // Create an image element
            var blurredImage = new Image();

            // Set the size of the image
            blurredImage.width = 400;
            blurredImage.height = 150;

            // Set the source of the image to the canvas content
            //blurredImage.src = canvas.toDataURL();
           // blurredImage.src = canvas.toDataURL();
           //blurredImage.src = "@/assets/img/img-blur.png"
           // this.getinfo_src=blurredImage.src
            this.check_img_show=true
        }
    }
        /* end here */

    },
    computed: {
      qualifications () {
        let list = []
        let selectedList = this.$lodash.concat(this.item.personal_questions_list)
        let catalog = this.$lodash.concat(this.$store.getters['catalogs/qualifications'])
        catalog.forEach((item) => {
          if (this.icons.includes(item.slug)) {
            list.push(Object.assign({}, item, {isActive: selectedList.includes(item.id)}))
          }
        })
        return list
      },
      caregivers () {
        let list = []
        let selectedList = this.item.caregiver_category_list
        let catalog =this.$lodash.concat(this.$store.getters['catalogs/caregivers'])
        console.log(selectedList);
            catalog.forEach((item) => {
            if (this.icons.includes(item.slug)) {
                list.push(Object.assign({}, item, {isActive: selectedList.includes(item.id)}))
            }
            })
        
        return list
      },
      typeWorkList () {
        let _work = this.item.type_work_list || []
        if (Array.isArray(_work)) {
          return this.$store.getters['catalogs/workTypes'].filter((item) => _work.includes(item.id))[0]
        }
        return _work
      },
      ageList () {
        let _age = this.item.child_age_list || []
        return this.$store.getters['catalogs/childAge'].filter((item) => _age.includes(item.id))
      },
      isParent () {
        return this.$auth.user().role === 'parent'
      },
      subscriptionExpired () {
        return this.$auth.user().subscription ? this.$auth.user().subscription.ended : null
      }
    },

    methods: {
        click_job_event(type){
            if(type=="job"){
                if (!this.$auth.check()) {
                    this.showSnackBar('Please login', 'success')
                    //this.$router.push({path: 'signup', query: {role: 'parent'} })
                    // this.$router.push('/login')
                    return
                }
                if(!this.isProfileCompleted()){
                    this.showSnackBar('Please complete your <a href="/profile" style="color: white; text-decoration: underline;">profile</a> in order to access NannyGranny content.', 'warning')
                    return
                }
            }
        },
      shortlist () {
        if (this.$auth.check()) {
          let _action = !this.item.is_favorite ? 'ADD' : 'DELETE'
          this.item.is_favorite = !this.item.is_favorite
          this.$store.dispatch(`favourites/FAVOURITES_${_action}`, {type: this.type, id: this.item.id})
              .catch(() => (this.item.is_favorite = !this.item.is_favorite))
        } else {
          this.$router.push('/login')
        }
      },
      viewprofile(){
        if (!this.$auth.check()) {
            if(this.type==='job'){
            //this.$router.push({path: 'signup', query: {role: 'parent'} })
            this.$router.push('/login')
            }
            else
            this.$router.push('/login')
        }
      },
      recommend () {
        this.$store.commit('dialog/DIALOG_SHOW', {
          show: true,
          component: 'app-dialog-recommend',
          data: {
            id: this.item.id,
            namespaced: (this.type === 'job') ? 'jobs' : 'nannies'
          },
          options: {
            maxWidth: 950
          }
        })
      },
      isProfileCompleted(){
        const storedUser = localStorage.getItem("auth._user");

        const CurrentUser = storedUser ? JSON.parse(storedUser) : {};
        
        return CurrentUser.is_jobprofilevisible === 1;
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .image-blur
        width 100%    
    ._card-item
        min-height 350px
        border-radius 0
        .blurredobjects
            text-shadow 0 0 8px #000
            color transparent
            -webkit-user-select none
            -ms-user-select none
            user-select none
 
        .blurreddiv-pricing
            width calc(100% + 20px);
            height 100%;
            position absolute;
            backdrop-filter blur(4px);
            text-shadow rgb(0, 0, 0) 0px 0px 8px;
            color transparent;
            margin 0px -10px;
            top 0px;    
        ._details
            > div:first-child
                max-width 120px

        .maindescription-parent
            position relative

            .blurreddiv
                width calc(100% + 20px);
                height 100%;
                position absolute;
                backdrop-filter blur(4px);
                text-shadow rgb(0, 0, 0) 0px 0px 8px;
                color transparent;
                margin 0px -10px;
                top 23px;

        ._qualifications
            overflow hidden
            width 100%
            color var(--grey_2)
            margin 20px 0 22px
            justify-content space-between

            > span
                display inline-block
                max-width 32px

            .svg-icon
                width 24px
                height 24px

        ._actions
            height 62px
        .d-link--contact, a
            padding 0 0 0 16px
            text-decoration none
            font-size 1em

            svg
                height 18px
                width 20px
                margin-right 2px
                margin-top: -4px

        ._desc
            word-wrap: break-word

        .new_desc
            word-break: unset !important

        .text-truncate
            line-height: unset !important

    @media (min-width: 600px)
        ._card-item
            ._details
                > div:first-child
                    max-width 168px

    @media (min-width: 960px)
        ._card-item
            border-radius 2px

            ._card--header
                padding 20px 8px 8px !important

            ._card-body
                min-height 337px
                padding 30px 12px

            ._qualifications
                margin-bottom 32px
                justify-content flex-start

                > span
                    max-width 60px

                .svg-icon
                    width 28px
                    height 28px

            &--small
                ._qualifications
                    margin-bottom 0
                    justify-content space-between

            ._actions--items
                display flex
                align-items center
                padding-left 12px

            a
                font-size 1.286em

    @media (min-width: 1264px)
        ._card-item
            ._actions--items
                > a, .d-link--contact
                    padding-right 31px
</style>



// WEBPACK FOOTER //
// src/components/app-card/listing/app-card-base.vue